import { URL_PATH, TOKEN_PATH, API_URL_PATH } from '../server/connection'
import {
    getAuthInfo,
    getReCaptchaToken,
    removeReCaptchaToken,
    removeTokenKey,
    setAuthInfo,
} from './dbHelpers'
import axios from 'axios/index'
import * as queryString from 'querystring'

export const removeAuthInfo = () => removeTokenKey()

export const userAuthInfoPresent = () => {
    return !!getAuthInfo()
}

const getErrorStatus = (error) => {
    try {
        return error.response.status
    } catch (e) {
        return null
    }
}

const getErrorResponseUrl = (error) => {
    try {
        return error.request.responseURL
    } catch (e) {
        return ''
    }
}

export const configureAuth = () => {
    axios.interceptors.request.use(
        (config) => {
            // Authorization
            let originalRequest = config
            var authInfo = getAuthInfo()
            if (authInfo && !config.url.includes(TOKEN_PATH))
                originalRequest.headers['Authorization'] =
                    'Bearer ' + authInfo.access_token

            // reCaptcha
            let reCaptchaToken = getReCaptchaToken()
            if (reCaptchaToken) {
                originalRequest.headers['reCaptcha'] = reCaptchaToken
                removeReCaptchaToken()
            }
            return originalRequest
        },
        (error) => Promise.reject(error)
    )

    axios.interceptors.response.use(
        (response) => {
            return response
        },
        (error) => {
            if (
                getErrorStatus(error) === 401 &&
                getErrorResponseUrl(error).includes(API_URL_PATH)
            ) {
                removeAuthInfo()
                return new Promise((resolve, reject) => {
                    window.location.reload()
                })
            }
            if (
                !!error.request &&
                !!error.request.responseType &&
                !!error.response &&
                !!error.response.data &&
                !!error.response.data.type &&
                error.request.responseType === 'blob' &&
                error.response.data instanceof Blob &&
                error.response.data.type.toLowerCase().indexOf('json') !== -1
            ) {
                return new Promise((resolve, reject) => {
                    let reader = new FileReader()
                    reader.onload = () => {
                        error.response.data = JSON.parse(reader.result)
                        resolve(Promise.reject(error))
                    }

                    reader.onerror = () => {
                        reject(error)
                    }

                    reader.readAsText(error.response.data)
                })
            }
            return Promise.reject(error)
        }
    )
}

export const getToken = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(URL_PATH + TOKEN_PATH, queryString.stringify(data), {
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                },
            })
            .then((response) => {
                setAuthInfo({
                    ...response.data,
                    access_token_expiration_ts:
                        Date.now() + response.data.expires_in * 1000,
                })
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
